import type { TRANS as TRANS_CS } from "./cs";

// stejne klice jako cs.ts, typ hlida, aby zadny preklad nechybel
export const TRANS: typeof TRANS_CS = {
	common: {
		male: "Male",
		female: "Female",
		send: "Send",
		amount: "{count} {count, plural, one {piece} other {pieces}}",
		amount2: "{count} {count, plural, one {teaspoon} other {teaspoons}}",
		amount3: "{count} {count, plural, one {tablespoon} other {tablespoons}}",
		amount4: "{count} {count, plural, one {handful} other {handfuls}}",
		amount5: "{count} {count, plural, one {pinch} other {pinches}}",
		amount6: "{count} {count, plural, one {leaf} other {leaves}}",
		amount7: "{count} {count, plural, one {sprig} other {sprigs}}",
		save: "Save",
		cancel: "Cancel",
		add: "Add",
		change: "Change",
		delete: "Delete",
		from: "From:",
		to: "To:",
		name: "First name",
		surname: "Last name",
		newsConsent: "I agree to receive useful tips and news",
		email: "Email",
		ingredient: "Ingredient",
		ingredients: "Ingredients",
		quantity: "Amount",
		tableEmpty: "The table is empty",
		missingValue: "No value entered!",
		date: "Date",
		value: "Value",
		portions: "{count} {count, plural, one {serving} other {servings}}",
	},
	mainPage: {
		title: "Home page",
		desc: "Home page description",
		plural: "{count, plural, =0 {There were} one {There was} other {There were}} {count} {count, plural, one {item} other {items}}",
	},
	loginPage: {
		title: "Login",
		emailLogged: "User {email}",
		subtitle: "Welcome back.",
		submit: "Log in",
		showPassword: "Show password",
		hidePassword: "Hide password",
		loginOffer: "Don't have an account?",
		register: "Sign up",
		email: "you@example.com",
		password: "password",
		verifyOffer: "Didn't get the verification email?",
		verifyLink: "Verify email",
		forgotPassword: "Forgot your password?",
		heroTitle: "A whole week of meals, planned for you",
		heroPoint1: "Meal plans based on your preferences",
		heroPoint2: "A shopping list made for you",
		heroPoint3: "Track your weight and measurements",
	},
	menu: {
		home: "Home",
		schedule: "Meal plan",
		profile: "Settings",
		userSection: "User section",
		logout: "Log out",
		languages: "Language",
		czech: "Čeština",
		english: "English",
		admin: "Administration",
		aboutus: "About us",
		gdpr: "GDPR",
		cookies: "Cookies",
		howitworks: "How it works",
		donation: "Support us",
		conditions: "Terms",
		statistics: "Personal statistics",
		login: "Login",
		register: "Sign up",
		verify: "Email verification",
		info: "Information",
		web: "doitforyourself.cz",
		notLogged: "Not logged in",
	},
	registerPage: {
		title: "Sign up",
		email: "Email",
		emailRequiredError: "Email is required!",
		emailFormatError: "Email is not in a valid format!",
		password: "Password",
		createAccount: "Create account",
		passwordRequiredError: "Password is required!",
		nameLabel: "First name",
		surnameLabel: "Last name",
		emailLabel: "Email",
		passwordLabel: "Password",
		passwordCheckLabel: "Confirm password",
		passwordCheck: "Confirm password",
		captchaError: "Please complete the captcha!",
		healthConsentBefore: "I consent to the processing of my health data (weight, body measurements, goals) to create my meal plan, as described in the",
		healthConsentLink: "privacy policy",
		healthConsentAfter: ".",
		healthConsentError: "We cannot create your meal plan without this consent.",
		submit: "Sign up",
		termsBefore: "By signing up you agree to the",
		termsLink: "terms",
		termsAfter: " and operating information",
		infoTitle: "Your personal meal plan for FREE",
		infoText: "To create your meal plan, we need to know details such as your weight, height, age, etc.",
		infoText2: "With an account you can also come back to your meal plan any time and track your progress. Everything is completely FREE with no hidden fees.",
		infoConfirm: "LET'S GO",
		subtitle: "Free, with no hidden fees.",
		loginOffer: "Already have an account?",
		loginLink: "Log in",
	},
	userPage: {
		title: "User section for {email}",
		userData: "User data",
		dataIsLoading: "Loading data...",
		unauthorized: "Please log in to continue",
	},
	adminPage: {
		unitsList: "Units",
		ingredients: "Ingredients",
		macrosList: "Macros",
		mealsList: "Meals",
		recipes: "Recipes",
		tags: "Tags",
		users: "Users",
		mailTemplates: "E-mails",
		menus: "Meal plans",
	},
	errors: {
		common: {
			unknown: "Something went wrong. Please try again.",
			saveFailed: "Changes could not be saved. Please try again.",
			loadFailed: "Data could not be loaded. Try refreshing the page.",
			missingData: "Some required information is missing. Please try again.",
			forbidden: "You are not allowed to do this.",
			network: "Could not connect to the server. Check your connection and try again.",
			sessionExpired: "Your session has expired, please log in again.",
		},
		login: {
			wrongCredentials: "Incorrect email or password.",
			notVerified: "Your email is not verified yet. Click the link in the email we sent you.",
			userExists: "An account with this email already exists. Try logging in.",
			healthConsent: "Consent to the processing of health data is required to register.",
			passwordTooShort: "Password must be at least {min} characters long.",
		},
		profile: {
			missingWeight: "Fill in your weight in personal details to calculate energy.",
			wrongPassword: "Incorrect password.",
			adminCannotDelete: "An administrator account cannot be deleted this way – another administrator has to delete it.",
		},
		menu: {
			generateFailed: "The meal plan could not be created, no suitable recipe was found for “{meal}”. Try changing your excluded ingredients.",
			noOtherRecipe: "No other recipe could be found for this meal.",
			pastDay: "Meals in the past cannot be swapped.",
			mealNotFound: "The meal was not found in the meal plan. Try refreshing the page.",
		},
		exercises: {
			generateFailed: "The training plan could not be created. Please try again.",
		},
		media: {
			imageNotFound: "Image not found.",
			uploadFailed: "The image could not be uploaded. Please try again.",
		},
		verify: {
			alreadyVerified: "The user has already been verified or does not exist.",
		},
		resetPassword: {
			invalidLink: "The password reset link is invalid or has expired. Please request a new one.",
		},
		rating: {
			neutralizeFirst: "Remove your current rating of the recipe first.",
		},
		users: {
			cannotDeleteSelf: "You cannot delete your own account.",
		},
		unsubscribe: {
			invalidLink: "Invalid unsubscribe link.",
		},
		mailing: {
			sendFailed: "The e-mail could not be sent: {detail}",
			templateIncomplete: "The template is missing the Czech or English version.",
			userNotFound: "User not found.",
		},
	},
	notifications: {
		login: {
			success: "You have been logged in!",
			afterRegistration: "Registration was successful, check your inbox for the verification email.",
			afterPasswordReset: "Your password has been changed, you can log in now.",
			emailResent: "The email has been sent again!",
			emptyEmail: "Fill in your email!",
			emptyPassword: "Fill in your password!",
		},
		register: {
			emptyName: "Fill in your first name!",
			emptySurname: "Fill in your last name!",
			emptyPasswordRepeat: "Enter your password again!",
		},
		profile: {
			updated: "Profile updated!",
			missingNewPassword: "New password is missing!",
			missingPasswordCheck: "Password confirmation is missing!",
			passwordsMismatch: "Passwords do not match!",
			missingOldPassword: "Current password is missing!",
			photoChanged: "Photo changed!",
			photoRemoved: "Photo removed!",
			accountDeleted: "Your account has been deleted.",
			readPhotoFailed: "The photo could not be loaded.",
			fillRequired: "Fill in all required details!",
			fields: {
				birthdate: "date of birth",
				weight: "weight",
				height: "height",
				sex: "sex",
			},
		},
		schedule: {
			maxDays: "The maximum number of days is {max}!",
			generated: "Meal plan created!",
			mealRegenerated: "Meal swapped!",
			recipeNotFound: "Recipe not found!",
			shoppingEmpty: "You have no meal plan for the selected days.",
		},
		stats: {
			valueAdded: "Value added!",
		},
		preferences: {
			addIngredientFailed: "The ingredient could not be added!",
			removeIngredientFailed: "The ingredient could not be removed!",
			addTagFailed: "The tag could not be added!",
			removeTagFailed: "The tag could not be removed!",
		},
		admin: {
			renamed: "Renamed!",
			missingTagName: "Tag name is missing!",
			missingIngredientName: "Ingredient name is missing!",
			dataUpdated: "Data updated!",
			emailResent: "The email has been sent again!",
		},
	},
	profilePage: {
		title: "Personal details",
		userEnergy: "Daily energy:",
		nameSection: "Name",
		address: "Address",
		street: "Street and number",
		city: "City",
		zipcode: "Postcode",
		country: "Country",
		menuData: "Details for calculating your meal plan",
		sex: "Sex",
		birthYear: "Year of birth",
		height: "Height [cm]",
		weight: "Weight [kg]",
		trainingPlan: "Training plan",
		foodPlan: "Meals per day",
		resultGroup: "Goal",
		maxDifficulty: "Maximum difficulty of generated recipes:",
		passwordChange: "Change password",
		oldPassword: "Current password",
		newPassword: "New password",
		passwordCheck: "Confirm password",
		other: "Other",
		mealsPerDay: "{count} times a day",
	},
	mobileWeek: {
		prevWeek: "Previous week",
		nextWeek: "Next week",
		goToday: "Go to today",
		pastDay: "Past day",
		today: "Today",
		cannotGenerate: "cannot be planned",
		noMenu: "no meal plan",
		pastDayInfo: "This day is over, a meal plan can no longer be created for it.",
		emptyDayInfo: "You don't have a meal plan for this day yet. Create one with the button below.",
		generate: "Plan",
		shopping: "Shopping",
		daysCount: "Number of days:",
		maxDays: "(at most {max})",
		replacedDays: "You already have a meal plan for {count} of the selected days, it will be replaced by a new one.",
		generating: "Planning…",
		showList: "Show list",
	},
	schedule: {
		generateMenu: "Create meal plan",
		shoppingList: "Shopping list",
		shoppingPdf: "Shopping list.pdf",
		menuCreation: "Meal plan creation",
		totalDays: "Total number of days:",
		yourDay: "Your day {date}",
		days: "Days {date}",
		showShoppingList: "Show shopping list",
		selectionError: "To create a meal plan, select only days that don't have one yet.",
		oldDate: "To create a meal plan, select upcoming days.",
		shoppingDesc: "Show a shopping list of the ingredients needed for the selected days.",
	},
	meals: {
		leftoverFromDay: "Leftovers from {day, select, 0 {Sunday} 1 {Monday} 2 {Tuesday} 3 {Wednesday} 4 {Thursday} 5 {Friday} other {Saturday}}",
		leftoverFromDate: "Leftovers from {date}",
		cookFor: "Cook for {count} days",
		regenerate: "Swap meal",
		title: "Meal plan",
		empty: "Empty",
		confirmTitle: "Swap a meal planned for several days?",
		confirmLabel: "Swap",
		confirmText: "is cooked for {count} days. Swapping it also changes its leftovers on these days:",
		confirmNote: "If you have already shopped according to the shopping list, the ingredients will differ.",
	},
	page404: {
		title: "Oops, we don't have that here!",
		text: "The page you are looking for doesn't exist or has been moved.",
		home: "Back to the home page",
	},
	accessGate: {
		forbiddenTitle: "You don't have access to this page",
		forbiddenText: "This page is only available to administrators.",
		back: "Back to meal plan",
		loginText: "The meal plan, shopping list and statistics are available after logging in.",
		noAccount: "Don't have an account?",
		register: "Sign up",
		noEmail: "Didn't get the verification email?",
		verify: "Verify email",
	},
	profileMeta: {
		photo: "Profile picture",
		choosePhoto: "Choose picture",
		darkMode: "Dark mode",
		lightMode: "Light mode",
		deleteAccount: "Delete account",
		deleteTitle: "Do you really want to delete your account?",
		deleteText: "All your data will be deleted too – meal plans, statistics, preferences and recipe ratings. This cannot be undone.",
		deletePassword: "Enter your password to confirm",
		deleteConfirm: "Delete account",
	},
	unsubscribePage: {
		title: "Newsletter",
		done: "You have been unsubscribed. We won't send you any more tips and news.",
		resubscribe: "If you change your mind, you can subscribe again in your personal details settings.",
	},
	stats: {
		weight: "Weight",
		waist: "Waist",
		chest: "Chest",
		side: "Hips",
		energy: "Energy",
		input: "Enter statistics",
		type: "Statistic type:",
		valueLabel: "Value:",
		addValue: "Add a new value",
		noData: "There are no values yet. Add the first one below.",
	},
	shopping: {
		title: "Shopping list",
		ingredient: "Ingredient",
	},
	preferencesPage: {
		title: "Preferences",
		excludedIngredients: "Excluded ingredients",
		addIngredient: "Add ingredient",
		ingredientsEmpty: "No ingredients excluded",
		excludedTags: "Excluded tags",
		tags: "Tags",
		addTag: "Add tag",
		tagsEmpty: "No tags excluded",
	},
	donation: {
		title: "THANK YOU FOR YOUR SUPPORT!",
		text: "We hope you enjoy the app. If you'd like to show your appreciation for the time we have put into it, you can send us a small thank-you. We truly value every bit of support.",
		card: "Card / Apple Pay",
		qr: "QR payment (39 CZK)",
		bank: "Fio bank:",
	},
	forgotPasswordPage: {
		title: "Forgot password",
		text: "Enter the email you signed up with and we'll send you a link to set a new password.",
		submit: "Send link",
		sent: "If an account with the email {email} exists, we've sent it a link to set a new password. The link is valid for 1 hour. Please check your spam folder too.",
		loginOffer: "Remembered it?",
	},
	resetPasswordPage: {
		title: "New password",
		text: "Choose a new password, at least {min} characters long.",
		passwordLabel: "New password",
		submit: "Save new password",
		newLink: "Send a new link",
	},
	favoriteRecipesPage: {
		title: "Favourite recipes",
		text: "Recipes you rated with a thumb in the recipe detail. We'll pick recipes you like for your meal plan more often and leave out the ones you don't like. Click the thumb to remove the rating.",
		liked: "I like it",
		disliked: "I don't like it",
		likedEmpty: "You don't have any favourite recipes yet.",
		dislikedEmpty: "You don't have any disliked recipes yet.",
	},
	recipeRating: {
		like: "I like it",
		dislike: "I don't like it",
		likes: "Number of likes",
		dislikes: "Number of dislikes",
		remove: "Remove rating",
		removeLikeFirst: "Remove your \"I like it\" rating first",
		removeDislikeFirst: "Remove your \"I don't like it\" rating first",
	},
	verifyPage: {
		title: "Email verification",
		text: "Enter the email you signed up with and we'll send you the verification link again.",
		submit: "Send verification email",
		loginOffer: "Already verified?",
		loginLink: "Log in",
		confirmTitle: "Email confirmation",
	},
	nutrition: {
		proteins: "Protein",
		proteinsShort: "P",
		carbohydrates: "Carbs",
		carbohydratesShort: "C",
		fats: "Fat",
		fatsShort: "F",
	},
	fillProfile: {
		before: "Your ",
		link: "profile",
		after: " is missing:",
	},
	difficulty: {
		level1: "Very easy",
		level2: "Easy",
		level3: "Medium",
		level4: "Hard",
		level5: "Very hard",
	},
	meta: {
		title: "Personalized meal plan | Do It For Yourself",
		description: "Professional online meal plan Do It For Yourself - completely FREE. Get an online meal plan tailored exactly to your needs, with the option of consulting a nutrition advisor.",
	},
	day: {
		monday: "Monday",
		tuesday: "Tuesday",
		wednesday: "Wednesday",
		thursday: "Thursday",
		friday: "Friday",
		saturday: "Saturday",
		sunday: "Sunday",
	},
};
